import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import {mapCustDutyResponseToForm,mapCustDutyFormToRequest} from "../../../../mappers/Import/CreateNewJob/mapCustDutyResponseToForm"
export const importProductCustDutyApi = createApi({
    reducerPath: "importProductCustDuty",
    baseQuery,
    tagTypes: ["importProductCustDuty"], ///v1/import/product/custDuty/{importProductId}
    endpoints: (builder) => ({
     
        createProductCustDuty: builder.mutation({
            query: ({ id, ...formData }) => {
              const mappedData = mapCustDutyFormToRequest(formData);
          
              return {
                url: `import/product/custDuty/${id}`,
                method: "PUT",
                headers: { 
                  "X-Request-Id": Math.random().toString(36).substring(2) 
                },
                body: {
                  customDuty: mappedData,   // ✅ correct backend model
                },
              };
            },
            invalidatesTags: ["importProductCustDuty"],
          }),
          

          updateProductCustDuty: builder.mutation({
            query: ({ id, subId, ...formData }) => {
              const mappedData = mapCustDutyFormToRequest(formData);
          
              return {
                url: `import/product/custDuty/${id}`,
                method: "PUT",
                body: {
                  customDuty: mappedData,   // ✅ correct mapper output
                },
                headers: {
                  "X-Request-Id": Math.random().toString(36).substring(2),
                },
              };
            },
            invalidatesTags: ["importProductCustDuty"],
          }),
          


          getProductCustDutyId: builder.query({
            query: ({ id }) => `import/product/custDuty/${id}`,
            transformResponse: (response) =>
              mapCustDutyResponseToForm(response?.data),
            providesTags: ["importProductCustDuty"],
          }),

        }), 
      });

    export const {
        useCreateProductCustDutyMutation,
        useUpdateProductCustDutyMutation,
        useLazyGetProductCustDutyIdQuery,
        } = importProductCustDutyApi;
